if (!customElements.get('master-filter')) {
  class MasterFilter extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-master-filter]')) {
          this.selectMasterFilter(event);
        }
      });
    }

    selectMasterFilter(event) {
      let filterValue = event.target.dataset.masterFilterValue;
      let filterLabel = event.target.dataset.masterFilter;

      let masterFilterWrapper = document.querySelector('[data-master-filter-select]');
      let masterFilter = masterFilterWrapper.querySelector('input[value="' + filterValue + '"]');
      let parent = event.target.parentElement;
      let parentClass = parent.classList;

      let filtersArr = masterFilterWrapper.querySelectorAll('input');

      // uncheck all filters
      filtersArr.forEach(function (filter) {
        filter.checked = false;
      });

      // check the master filter
      if (masterFilter) {
        if (!parentClass.contains('filter-active')) {
          document.querySelector('.filter-active').classList.remove('filter-active');
          masterFilter.checked = true;
          parent.classList.add('filter-active');
        } else {
          document.querySelector('.filter-active').classList.remove('filter-active');
          document
            .querySelector('[data-master-filter-value="all"]')
            .parentElement.classList.add('filter-active');
        }
      }

      // dispatch submit event to collection filters form
      document.querySelector('collection-filters-form form').dispatchEvent(
        new CustomEvent('custom-input', {
          bubbles: true,
          composed: true,
          detail: {
            masterFilterLabel: filterLabel,
            masterFilterValue: filterValue,
          },
        })
      );

    }
  }

  window.MasterFilter = MasterFilter;
  customElements.define('master-filter', MasterFilter);
}
